
import { defineComponent, PropType } from "vue";
import { RouterLink } from "vue-router";

import { Category } from "../data/types";
import common from "../styles/common.module.less";
import { Icon } from "./icons";

export default defineComponent({
  name: "XiyouCategoryEntry",
  props: {
    category: { type: Object as PropType<Category>, required: true },
    count: { type: Number, default: 0 },
  },
  setup(props) {
    return () => (
      <RouterLink
        class={common.categoryEntry}
        to={{ name: "XiyouPortal", query: { category: props.category.slug } }}
      >
        <span class={common.categoryIcon}>
          <Icon name={props.category.icon} />
        </span>
        <span class={common.categoryName}>{props.category.name}</span>
        <span class={common.categoryDesc}>{props.category.desc}</span>
        <span class={common.categoryCount}>共 {props.count} 条信息</span>
      </RouterLink>
    );
  },
});
